import React from 'react';
import { JBUserAvatar } from '@jbhi-fi/lanyard-ui';
import { styles } from './UserProfile.css';

export interface UserProfileProps {
  name: string;
  position?: string | null;
  photoSrc?: string | null;
}

export const UserProfile = ({ name, position, photoSrc }: UserProfileProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.userPhotoContainer}>
        <JBUserAvatar userPhoto={photoSrc} size={45} name={name} fontSize={15} fontSizeUnit="px" />
      </div>
      <div className={styles.userDetailsContainer}>
        <p className={styles.userName}>{name}</p>
        {position ? <p className={styles.userPosition}>{position}</p> : null}
      </div>
    </div>
  );
};
